/**
 * Mock data condiviso per il Component Playground.
 * Nessuna chiamata API: tutti i valori sono statici, safe per rendering isolato.
 */

export const mockUser = {
  _id: "usr-mock-1",
  id: "usr-mock-1",
  email: "demo@housetag.it",
  first_name: "Mario",
  last_name: "Rossi",
  role: "professional",
  status: "approved",
  auth_provider: "local",
  parent_user_id: null,
  subuser_can_add_margin: true,
  subuser_max_margin_pct: 25.0,
  default_service_markup_pct: 30.0,
  professional_price: 110.0,
};

export const mockSubUser = {
  ...mockUser,
  _id: "usr-mock-sub",
  id: "usr-mock-sub",
  parent_user_id: "usr-mock-1",
};

export const mockProperties = [
  {
    _id: "prop-1",
    address: "Via Roma 12/B",
    city: "Milano",
    province: "MI",
    zip_code: "20121",
    owner_first_name: "Giulia",
    owner_last_name: "Bianchi",
    owner_phone: "+39 333 1234567",
  },
  {
    _id: "prop-2",
    address: "Via delle Rose 8",
    city: "Monza",
    province: "MB",
    zip_code: "20900",
    owner_first_name: "Marco",
    owner_last_name: "Verdi",
    owner_phone: "+39 333 9876543",
  },
  {
    _id: "prop-3",
    address: "Corso Buenos Aires 45",
    city: "Milano",
    province: "MI",
    zip_code: "20124",
    owner_first_name: "Anna",
    owner_last_name: "Neri",
    owner_phone: "",
  },
];

export const mockService = {
  _id: "svc-1",
  name: "APE",
  slug: "ape",
  category: "Certificazioni",
  description: "Servizio professionale per pratiche immobiliari",
  icon: "Lightbulb",
  professional_price: 110.0,
  base_price: 130.0,
  delivery_days: 7,
  requires_visit: true,
  chained_service_ids: [],
  client_info: "L'APE (Attestato di Prestazione Energetica) è obbligatorio per compravendite e locazioni.",
  keywords: ["APE", "energetico", "certificazione"],
  split_payment_enabled: true,
  advance_percentage: 40,
};

export const mockServices = [
  mockService,
  {
    _id: "svc-2",
    name: "Accesso agli Atti",
    slug: "atti",
    category: "Pratiche",
    description: "Recupero documentazione presso archivi comunali",
    icon: "FileText",
    professional_price: 200.0,
    delivery_days: 7,
    requires_visit: false,
    chained_service_ids: [],
    client_info: "",
    keywords: [],
  },
  {
    _id: "svc-3",
    name: "Sanatoria Edilizia",
    slug: "sanatoria",
    category: "Pratiche",
    description: "Regolarizzazione difformità edilizie",
    icon: "Buildings",
    professional_price: 800.0,
    delivery_days: 30,
    requires_visit: true,
    chained_service_ids: ["svc-2"],
    client_info: "",
    keywords: [],
  },
];

export const mockChainedServices = [
  {
    _id: "svc-chain-1",
    name: "Visura Catastale",
    category: "Documenti",
    professional_price: 25.0,
  },
  {
    _id: "svc-chain-2",
    name: "Planimetria",
    category: "Documenti",
    professional_price: 45.0,
  },
];

export const mockQuote = {
  _id: "q-1",
  service_id: "svc-1",
  service_name: "APE",
  property_id: "prop-1",
  property_summary: "Via Roma 12/B, Milano",
  price_excl_vat: 150.0,
  vat_rate: 22,
  total_incl_vat: 183.0,
  notes: "Preventivo valido 30 giorni",
  created_at: new Date(Date.now() - 3 * 24 * 3600 * 1000).toISOString(),
  expires_at: new Date(Date.now() + 27 * 24 * 3600 * 1000).toISOString(),
};

export const mockQuotes = [
  mockQuote,
  {
    ...mockQuote,
    _id: "q-2",
    service_name: "Accesso agli Atti",
    total_incl_vat: 305.0,
    expires_at: new Date(Date.now() + 5 * 24 * 3600 * 1000).toISOString(), // scade fra 5gg (warning)
  },
];

export const mockInProgressPractices = [
  {
    _id: "prc-1",
    service_name: "APE",
    property_id: "prop-1",
    total_price: 110.0,
    created_at: new Date(Date.now() - 2 * 24 * 3600 * 1000).toISOString(),
    current_step_name: "Sopralluogo programmato",
    status: "in_progress",
    is_shared_with_client: false,
    payment_status: "via_plafond",
  },
  {
    _id: "prc-2",
    service_name: "Sanatoria Edilizia",
    property_id: "prop-2",
    total_price: 950.0,
    created_at: new Date(Date.now() - 5 * 24 * 3600 * 1000).toISOString(),
    current_step_name: "Attesa documenti cliente",
    status: "waiting_approval",
    is_shared_with_client: true,
    payment_status: "pending",
  },
  {
    _id: "prc-3",
    service_name: "Accesso agli Atti",
    property_id: "prop-3",
    total_price: 250.0,
    created_at: new Date(Date.now() - 10 * 24 * 3600 * 1000).toISOString(),
    current_step_name: "In lavorazione",
    status: "assigned",
    is_shared_with_client: true,
    payment_status: "paid",
  },
];

export const mockRecap = [
  {
    year: 2026,
    month: 2,
    label: "Febbraio 2026",
    plafond_used: 320.0,
    credit_earned: 145.0,
    net_due: 175.0,
    practices: [
      {
        id: "rc-1",
        service_name: "APE",
        address: "Via Roma 12, Milano",
        client: "G. Bianchi",
        completed_at: new Date().toISOString(),
        payment_type: "plafond",
        margin: 0,
      },
      {
        id: "rc-2",
        service_name: "Accesso agli Atti",
        address: "Via delle Rose 8, Monza",
        client: "M. Verdi",
        completed_at: new Date().toISOString(),
        payment_type: "client",
        margin: 45.0,
      },
    ],
  },
];

export const mockShareLinkInfo = {
  url: "https://realestate-hub-724.preview.emergentagent.com/pay/prc-mock-123",
  practice_id: "prc-mock-123",
  client_name: "Giulia Bianchi",
  client_email: "giulia.bianchi@example.com",
};

export const mockSlotMonth = () => {
  const d = new Date();
  return { year: d.getFullYear(), month: d.getMonth() + 1 };
};

// Genera monthGrid+slot fittizi per SlotPicker
export const buildMockMonthGrid = () => {
  const { year, month } = mockSlotMonth();
  const first = new Date(year, month - 1, 1);
  const firstDayIdx = (first.getDay() + 6) % 7;
  const daysInMonth = new Date(year, month, 0).getDate();
  const cells = [];
  for (let i = 0; i < firstDayIdx; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) {
    const dateStr = `${year}-${String(month).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
    // Slot disponibili solo in giorni pari, per demo
    cells.push({ day: d, date: dateStr, hasSlots: d % 2 === 0 });
  }
  while (cells.length % 7 !== 0) cells.push(null);
  return cells;
};

export const mockSlots = [
  { date: "", hour: 9, best_operator: { id: "op-1", name: "Luca Neri" } },
  { date: "", hour: 10, best_operator: { id: "op-1", name: "Luca Neri" } },
  { date: "", hour: 14, best_operator: { id: "op-2", name: "Sara Bianchi" } },
  { date: "", hour: 15, best_operator: { id: "op-2", name: "Sara Bianchi" } },
];
